import useReveal from "@/hooks/useReveal";
import { mission } from "@/lib/home-content";

export default function Mission() {
    const { ref, visible } = useReveal();

    return (
        <section className="bg-white px-5 py-16 sm:py-24">
            <div ref={ref} className={`reveal mx-auto max-w-3xl text-center ${visible ? "is-visible" : ""}`}>
                <span className="text-xs font-semibold uppercase tracking-[0.18em] text-[var(--brand)]">
                    {mission.kicker}
                </span>
                <h2 className="mt-5 font-display text-4xl font-extrabold leading-[1.04] text-[#0a0a0b] sm:text-6xl">
                    {mission.lead}
                    <br />
                    {mission.words.map((w, i) => (
                        <span
                            key={w}
                            className="mission-word inline-block text-[var(--brand)]"
                            style={{ transitionDelay: `${250 + i * 180}ms` }}
                        >
                            {w}
                            {i < mission.words.length - 1 ? "\u00A0" : ""}
                        </span>
                    ))}
                </h2>
                <p className="mx-auto mt-6 max-w-2xl text-[15px] leading-relaxed text-[#5b5b66] sm:text-lg">
                    {mission.body}
                </p>
            </div>
        </section>
    );
}
